/** Disparado ao final de refreshData (botão Atualizar / auto-refresh do Board). */
export const BOARD_DATA_REFRESH_EVENT = 'painel-board-data-refresh';

export function dispatchBoardDataRefresh() {
  try {
    window.dispatchEvent(new CustomEvent(BOARD_DATA_REFRESH_EVENT));
  } catch (_) {
    /* ignore */
  }
}
